import { addNotificationToApp, NotificationType } from './NotificationsActions';
import { EnrollmentPackageId } from '../types/api/primaryKeys/PrimaryKey';
import { PackageSummaryPolicy } from '../types/api/enrollmentPackages/PackageSummaryPolicy';
import { ReduxDispatch } from '../types/redux/ReduxDispatch';
import * as Api from '../apiCalls/summary/summaryApiCalls';
import { PackageSummaryPerson } from '../types/api/enrollmentPackages/PackageSummaryPerson';

export enum SummaryActionType {
    FETCH_SUMMARY_PEOPLE = 'FETCH_SUMMARY_PEOPLE',
    FETCH_SUMMARY_PEOPLE_SUCCESS = 'FETCH_SUMMARY_PEOPLE_SUCCESS',
    FETCH_SUMMARY_PEOPLE_FAILURE = 'FETCH_SUMMARY_PEOPLE_FAILURE',

    FETCH_SUMMARY_POLICIES = 'FETCH_SUMMARY_POLICIES',
    FETCH_SUMMARY_POLICIES_SUCCESS = 'FETCH_SUMMARY_POLICIES_SUCCESS',
    FETCH_SUMMARY_POLICIES_FAILURE = 'FETCH_SUMMARY_POLICIES_FAILURE'
}

export type SummaryAction = 
    | ReturnType<typeof requestSummaryPeople>
    | ReturnType<typeof requestSummaryPeopleSuccess>
    | ReturnType<typeof requestSummaryPeopleFailure>

    | ReturnType<typeof requestSummaryPolicies>
    | ReturnType<typeof requestSummaryPoliciesSuccess>
    | ReturnType<typeof requestSummaryPoliciesFailure>;


function requestSummaryPeople() {
    return {
        type: SummaryActionType.FETCH_SUMMARY_PEOPLE
    } as const;
}

function requestSummaryPeopleSuccess(people: readonly PackageSummaryPerson[]) {
    return {
        type: SummaryActionType.FETCH_SUMMARY_PEOPLE_SUCCESS,
        payload: people
    } as const;
}

function requestSummaryPeopleFailure(error: unknown) {
    return {
        type: SummaryActionType.FETCH_SUMMARY_PEOPLE_FAILURE,
        payload: error
    } as const;
}

export function fetchSummaryPeople(packageId: EnrollmentPackageId) {
    return async (dispatch: ReduxDispatch) => {
        dispatch(requestSummaryPeople());

        try {
            const json = await Api.getPackageSummaryPeople(packageId);
            dispatch(requestSummaryPeopleSuccess(json));
        }
        catch (err) {
            dispatch(requestSummaryPeopleFailure(err));
            dispatch(addNotificationToApp("Failed To Fetch Summary of People", NotificationType.Error));
        }
    };
}

function requestSummaryPolicies() {
    return {
        type: SummaryActionType.FETCH_SUMMARY_POLICIES
    } as const;
}

function requestSummaryPoliciesSuccess(policies: readonly PackageSummaryPolicy[]) {
    return {
        type: SummaryActionType.FETCH_SUMMARY_POLICIES_SUCCESS,
        payload: policies
    } as const;
}

function requestSummaryPoliciesFailure(error: unknown) {
    return {
        type: SummaryActionType.FETCH_SUMMARY_POLICIES_FAILURE,
        payload: error
    } as const;
}

export function fetchSummaryPolicies(packageId: EnrollmentPackageId) {
    return async (dispatch: ReduxDispatch) => {
        dispatch(requestSummaryPolicies());

        try {
            const json = await Api.getPackageSummaryPolicies(packageId);
            dispatch(requestSummaryPoliciesSuccess(json));
        }
        catch (err) {
            dispatch(requestSummaryPoliciesFailure(err));
            dispatch(addNotificationToApp("Failed To Fetch Summary of Policies", NotificationType.Error));
        }
    };
}
